import * as React from "react";
import { theme } from "../../../theme";

interface Props {
  color?: string;
}

export const AgreementIcon: React.FC<Props> = ({
  color = theme.colors.text,
}) => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M14.6673 4.5013H12.8081C12.4073 4.5013 12.2069 4.5013 12.018 4.44409C11.829 4.38688 11.6623 4.27574 11.3289 4.05344C10.8287 3.71999 10.2581 3.3396 9.97465 3.25378C9.69125 3.16797 9.39065 3.16797 8.78952 3.16797C7.97205 3.16797 7.44512 3.16797 7.07758 3.32021C6.71005 3.47245 6.42102 3.76148 5.84296 4.33954L5.33424 4.84826C5.20397 4.97854 5.13883 5.04368 5.09862 5.10798C4.94955 5.34638 4.96607 5.65267 5.13991 5.87364C5.18681 5.93326 5.25858 5.99101 5.4021 6.10652C5.93262 6.53346 6.69745 6.49085 7.17785 6.00758L8.00065 5.17988H8.66732L12.6673 9.20368C13.0355 9.57408 13.0355 10.1745 12.6673 10.5449C12.2991 10.9153 11.7022 10.9153 11.334 10.5449L11.0007 10.2096M11.0007 10.2096L9.00065 8.19775M11.0007 10.2096C11.3689 10.58 11.3689 11.1805 11.0007 11.5509C10.6325 11.9213 10.0355 11.9213 9.66732 11.5509L9.00065 10.8803M9.00065 10.8803C9.36885 11.2506 9.36885 11.8511 9.00065 12.2215C8.63245 12.5919 8.03552 12.5919 7.66732 12.2215L6.66732 11.2155M9.00065 10.8803L7.66732 9.54695M6.66732 11.2155L6.33398 10.8803M6.66732 11.2155C7.03552 11.5859 7.03552 12.1865 6.66732 12.5569C6.29913 12.9272 5.70218 12.9272 5.33398 12.5569L3.45156 10.6352C3.06475 10.2403 2.87134 10.0429 2.62355 9.93875C2.37576 9.83461 2.09937 9.83461 1.54661 9.83461H1.33398"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M14.6667 9.83203H13"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
    />
    <path
      d="M5.66732 4.5H1.33398"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
    />
  </svg>
);
